<script setup>
import { useWebStore } from '~/store/web'
import NavBarItem from '~/components/NavBarItem.vue'

const props = defineProps({
  site: { type: Object, required: true },
})

const store = useWebStore()
const open = ref(false)
const route = useRoute()

// Route-váltásra zárunk, különben a menü nyitva marad a navigáció után.
watch(() => route.fullPath, () => { open.value = false })

function onKeydown(event) {
  if (event.key === 'Escape') open.value = false
}
</script>

<template>
  <div
    class="relative h-full"
    @mouseenter="open = true"
    @mouseleave="open = false"
    @keydown="onKeydown"
  >
    <NuxtLink
      :to="'/' + store.chosenLang + '/' + site.url"
      class="unstyled-link nav-link h-full flex items-center"
      :aria-expanded="open"
      aria-haspopup="true"
    >
      <nav-bar-item
        :id="'nav_' + site.url"
        :text="site.text"
        :link="site.url"
        :has-children="true"
      />
      <span class="ml-1 text-xs" :class="open ? 'rotate-180' : ''" aria-hidden="true">▾</span>
    </NuxtLink>

    <transition name="dropdown-fade">
      <ul
        v-if="open"
        class="absolute left-0 top-full z-50 w-max min-w-full bg-white deep-shadow py-2 list-none m-0 text-left"
      >
        <li v-for="child in site.children" :key="child.url">
          <NuxtLink
            :to="'/' + store.chosenLang + '/' + child.url"
            class="unstyled-link dropdown-child block px-5 py-3 InterMedium whitespace-nowrap"
            :class="{ 'is-active': store.chosenTab === child.url }"
          >
            {{ child.text }}
          </NuxtLink>
        </li>
      </ul>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

// A `bg-light-grey` a globalStyle saját osztálya, ezért Tailwind hover: variánst
// nem lehet rá képezni — a hover állapot itt, scoped CSS-ben él.
// Az `.unstyled-link` `cursor: auto`-t állít, ezért a lenyíló elemek felett
// nem jelent meg a kézkurzor.
.dropdown-child {
  cursor: pointer;
}

.dropdown-child:hover {
  background-color: #F5F5F5;
}

// Az `.orangeText` itt nem elég: a globalStyle-ban a `.unstyled-link { color: inherit }`
// később áll azonos specificitással, ezért felülírná. A scoped selector attribútuma
// megemeli a specificitást, így az aktív al-oldal ténylegesen narancs lesz.
.dropdown-child.is-active {
  color: rgb(255, 118, 24);
  font-weight: 700;
}
</style>
